module.exports = __webpack_public_path__ + "static/logo-fa1312c8325efdcabfd256270c808e08.svg";